import {useId, useState} from "react";
import {ReactIsland} from "@/shared/reactIsland";
import {Select} from "@/primitives/Select";

/** Submitted with the page-wide settings form, under the same name the legacy select used. */
const FIELD_NAME = "showExternalId";

export interface IntegrationsGeneralPanelProps {
	showExternalId: boolean;
	onChange?: () => void;
}


export function IntegrationsGeneralPanel({
	showExternalId: initialShowExternalId,
	onChange,
}: IntegrationsGeneralPanelProps) {
	const [showExternalId, setShowExternalId] = useState(initialShowExternalId ? "true" : "false");
	const selectId = useId();

	const items = [
		{label: messages["admin.clientSettings.showExternalId.true"], value: "true"},
		{label: messages["admin.clientSettings.showExternalId.false"], value: "false"},
	];

	return (
		<div className="panel panel-flat">
			<div className="panel-heading">
				<h6 className="panel-title">{messages["admin.settings.general"]}</h6>
			</div>
			<div className="panel-body">
				<div className="form-horizontal">
					<div className="form-group">
						<label className="control-label col-lg-3" htmlFor={selectId}>
							{messages["admin.clientSettings.showExternalId"]}
						</label>
						<div className="col-lg-9">
							<Select.Root
								items={items}
								name={FIELD_NAME}
								value={showExternalId}
								onValueChange={(value) => {
									setShowExternalId(value);
									onChange?.();
								}}
							>
								<Select.Trigger id={selectId}/>
								<Select.Items/>
							</Select.Root>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export function mountIntegrationsGeneralPanelIsland(
	mountId: string,
	showExternalId: boolean,
	onChange?: () => void,
): ReactIsland<IntegrationsGeneralPanelProps> | undefined {
	const mount = document.getElementById(mountId);
	if (!mount) {
		console.warn(`No mount point "${mountId}" for the integrations general panel`);
		return undefined;
	}

	return new ReactIsland<IntegrationsGeneralPanelProps>(
		IntegrationsGeneralPanel,
		{showExternalId, onChange},
		mount,
	);
}
